import React, { useState } from 'react';

const CyberChef = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [recipe, setRecipe] = useState('base64-encode');

  // Encoding/Decoding functions
  const base64Encode = (str) => {
    try {
      return btoa(unescape(encodeURIComponent(str)));
    } catch (e) {
      return 'Error: Invalid input';
    }
  };

  const base64Decode = (str) => {
    try {
      return decodeURIComponent(escape(atob(str)));
    } catch (e) {
      return 'Error: Invalid base64';
    }
  };

  const hexEncode = (str) => {
    return Array.from(str).map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
  };

  const hexDecode = (str) => {
    try {
      return str.match(/.{1,2}/g).map(byte => String.fromCharCode(parseInt(byte, 16))).join('');
    } catch (e) {
      return 'Error: Invalid hex';
    }
  };

  const urlEncode = (str) => encodeURIComponent(str);
  const urlDecode = (str) => {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return 'Error: Invalid URL encoding';
    }
  };



  const sha1 = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-1', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  };

  const sha256 = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  };

  const rot13 = (str) => {
    return str.replace(/[a-zA-Z]/g, c => String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26));
  };

  const reverse = (str) => str.split('').reverse().join('');

  const toUpperCase = (str) => str.toUpperCase();
  const toLowerCase = (str) => str.toLowerCase();

  const processRecipe = async () => {
    let result = '';
    try {
      switch (recipe) {
        case 'base64-encode':
          result = base64Encode(input);
          break;
        case 'base64-decode':
          result = base64Decode(input);
          break;
        case 'hex-encode':
          result = hexEncode(input);
          break;
        case 'hex-decode':
          result = hexDecode(input);
          break;
        case 'url-encode':
          result = urlEncode(input);
          break;
        case 'url-decode':
          result = urlDecode(input);
          break;
        case 'sha1':
          result = await sha1(input);
          break;
        case 'sha256':
          result = await sha256(input);
          break;
        case 'rot13':
          result = rot13(input);
          break;
        case 'reverse':
          result = reverse(input);
          break;
        case 'uppercase':
          result = toUpperCase(input);
          break;
        case 'lowercase':
          result = toLowerCase(input);
          break;
        default:
          result = '';
      }
      setOutput(result);
    } catch (e) {
      setOutput(`Error: ${e.message}`);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
  };

  const swapInputOutput = () => {
    setInput(output);
    setOutput(input);
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%',
      padding: '15px',
      gap: '10px',
      fontFamily: '"JetBrains Mono", "SF Mono", "Monaco", monospace',
      fontSize: '13px',
      color: '#cbd5e1'
    }}>
      {/* Recipe Selector */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <label style={{ fontSize: '12px', color: '#60a5fa', fontWeight: '600' }}>Recipe:</label>
        <select 
          value={recipe} 
          onChange={(e) => setRecipe(e.target.value)}
          style={{
            padding: '6px 10px',
            borderRadius: '6px',
            border: '1px solid rgba(96, 165, 250, 0.3)',
            background: 'rgba(30, 41, 59, 0.8)',
            color: '#cbd5e1',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            cursor: 'pointer'
          }}
        >
          <optgroup label="Encoding">
            <option value="base64-encode">Base64 Encode</option>
            <option value="base64-decode">Base64 Decode</option>
            <option value="hex-encode">Hex Encode</option>
            <option value="hex-decode">Hex Decode</option>
            <option value="url-encode">URL Encode</option>
            <option value="url-decode">URL Decode</option>
          </optgroup>
          <optgroup label="Hashing">
            <option value="sha1">SHA1</option>
            <option value="sha256">SHA256</option>
          </optgroup>
          <optgroup label="String Operations">
            <option value="rot13">ROT13</option>
            <option value="reverse">Reverse</option>
            <option value="uppercase">Uppercase</option>
            <option value="lowercase">Lowercase</option>
          </optgroup>
        </select>
      </div>

      {/* Input */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <label style={{ fontSize: '12px', color: '#60a5fa', fontWeight: '600', marginBottom: '4px' }}>Input:</label>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter text here..."
          style={{
            flex: 1,
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid rgba(96, 165, 250, 0.2)',
            background: 'rgba(15, 23, 42, 0.6)',
            color: '#cbd5e1',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            resize: 'none',
            outline: 'none'
          }}
        />
      </div>

      {/* Controls */}
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={processRecipe}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: '1px solid #60a5fa',
            background: 'rgba(96, 165, 250, 0.1)',
            color: '#60a5fa',
            fontWeight: '600',
            fontSize: '12px',
            cursor: 'pointer',
            transition: 'all 0.2s',
            flex: 1
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(96, 165, 250, 0.2)';
            e.target.style.boxShadow = '0 0 12px rgba(96, 165, 250, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(96, 165, 250, 0.1)';
            e.target.style.boxShadow = 'none';
          }}
        >
          🔄 Process
        </button>
        <button
          onClick={swapInputOutput}
          style={{
            padding: '8px 12px',
            borderRadius: '6px',
            border: '1px solid rgba(96, 165, 250, 0.3)',
            background: 'rgba(30, 41, 59, 0.8)',
            color: '#cbd5e1',
            fontSize: '12px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(96, 165, 250, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(30, 41, 59, 0.8)';
          }}
          title="Swap input and output"
        >
          ⇅
        </button>
      </div>

      {/* Output */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <label style={{ fontSize: '12px', color: '#60a5fa', fontWeight: '600', marginBottom: '4px' }}>Output:</label>
        <textarea
          value={output}
          readOnly
          placeholder="Output will appear here..."
          style={{
            flex: 1,
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid rgba(96, 165, 250, 0.2)',
            background: 'rgba(15, 23, 42, 0.6)',
            color: '#60a5fa',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            resize: 'none',
            outline: 'none',
            cursor: 'text'
          }}
        />
      </div>

      {/* Copy Button */}
      <button
        onClick={copyToClipboard}
        disabled={!output}
        style={{
          padding: '8px 16px',
          borderRadius: '6px',
          border: '1px solid rgba(96, 165, 250, 0.3)',
          background: output ? 'rgba(96, 165, 250, 0.1)' : 'rgba(96, 165, 250, 0.05)',
          color: output ? '#60a5fa' : 'rgba(96, 165, 250, 0.5)',
          fontWeight: '600',
          fontSize: '12px',
          cursor: output ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          if (output) {
            e.target.style.background = 'rgba(96, 165, 250, 0.2)';
            e.target.style.boxShadow = '0 0 12px rgba(96, 165, 250, 0.2)';
          }
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(96, 165, 250, 0.1)';
          e.target.style.boxShadow = 'none';
        }}
      >
        📋 Copy Output
      </button>

      {/* Footer Credit */}
      <div style={{ 
        textAlign: 'center', 
        fontSize: '11px', 
        color: 'rgba(203, 213, 225, 0.5)',
        marginTop: '8px',
        paddingTop: '8px',
        borderTop: '1px solid rgba(96, 165, 250, 0.1)'
      }}>
        made with ❤️ by Diptanshu Dhawan
      </div>
    </div>
  );
};

export default CyberChef;
